﻿import StSidebar from './StSidebar.vue';
import { mountAppStudioPage } from './Vue3/app-studio-page-mount';

mountAppStudioPage({
    root: '#app-sidebar-vue',
    propsElement: '#app-sidebar-props',
    component: StSidebar
});
